module.exports = {"account":"Log-in to your account","login":"Log In","remember":"Remember","email":"Email","password":"Password","error":"Required!","emailerror":"Invalid email address"}


//////////////////
// WEBPACK FOOTER
// ./src/wording/pages/login/ENG.json
// module id = 893
// module chunks = 150